import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, Input, InputNumber, Row, Col } from 'hljd'
import { observer } from 'mobx-react'
import { Flex } from 'hljd'
import Upload from '../../Upload'
import { leftColumns, rightColumns } from './columns'
import { Exhibition } from 'hlj-components'
import Attachments from '@common/Attachments'
import style from './style.module.less'

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 }
}

@Form.create()
@observer
export default class extends Component {
  submit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.store.createBrokerageOrder({
          ...values,
          attachments: JSON.stringify(values.attachments)
        })
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const {
      applyDeductFeeModalVisible,
      closeApplyDeductFeeModal,
      currentCooperateOrder,
      currentBrokerageOrder
    } = this.props.store
    const {
      innerRemark,
      remark,
      money,
      attachments: brokerageOrderAttachments
    } = currentBrokerageOrder

    return (
      <Modal
        title="申请扣除服务费"
        visible={applyDeductFeeModalVisible}
        onOk={this.submit}
        onCancel={() => closeApplyDeductFeeModal()}
        width={600}
      >
        <div>
          <Flex>
            <div style={{ marginRight: 20 }}>
              <Exhibition columns={leftColumns} data={currentCooperateOrder} />
            </div>

            <div>
              <Exhibition columns={rightColumns} data={currentCooperateOrder} />
            </div>
          </Flex>

          <Exhibition
            columns={[
              {
                dataIndex: 'orderText',
                title: '订单信息',
                render: (o, { orderText, attachments }) => {
                  return (
                    <div>
                      <div>{orderText}</div>
                      <Attachments showUpload={false} value={attachments} />
                    </div>
                  )
                }
              }
            ]}
            data={currentCooperateOrder}
          />
        </div>

        <div className={style.formArea}>
          {applyDeductFeeModalVisible && (
            <Form>
              <Form.Item {...layout} label="服务费金额">
                {getFieldDecorator('money', {
                  initialValue: money || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入服务费金额'
                    }
                  ]
                })(<InputNumber placeholder="请输入" />)}
              </Form.Item>

              <Form.Item {...layout} label="费用备注">
                {getFieldDecorator('remark', {
                  initialValue: remark || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入费用备注'
                    }
                  ]
                })(<Input placeholder="请输入" />)}
              </Form.Item>

              <Row>
                <Col span={5} />
                <Col span={6}>
                  {getFieldDecorator('attachments', {
                    initialValue: brokerageOrderAttachments || []
                  })(<Upload />)}
                </Col>
              </Row>

              <Form.Item {...layout} label="内部备注">
                {getFieldDecorator('inner_remark', {
                  initialValue: innerRemark || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入内部备注'
                    }
                  ]
                })(<Input placeholder="请输入" />)}
              </Form.Item>
            </Form>
          )}
        </div>

        <div style={{ marginTop: 10 }}>
          内部审批通过后，将自动从商家服务费账户中扣款。商家可以看到此笔扣款的信息
        </div>
      </Modal>
    )
  }
}
